<template>
  <div>
    <NitroPayAd v-for="ad in ads" :key="ad.breakpoint" :id="`${config.id}-${ad.breakpoint ? ad.breakpoint : 'default'}`" :ad-sizes="ad.sizes" :media-query="ad.mediaQuery" :with-fallback="ad.sizes?.includes(MediumRectangle)" />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import {
  AdSize, Breakpoint, mediaQuery, MediumRectangle,
} from '@/common/adSizes';
import NitroPayAd from '@/components/ads/NitroPayAd.vue';
import { AdUnit } from '@/common/adSlots';

const props = defineProps({
  config: {
    type: Object as PropType<AdUnit>,
    required: true,
  },
});

const ads = computed(() => {
  const definedBreakpoints = [
    { breakpoint: undefined, sizes: props.config.default },
    { breakpoint: 'sm' as Breakpoint, sizes: props.config.sm },
    { breakpoint: 'md' as Breakpoint, sizes: props.config.md },
    { breakpoint: 'lg' as Breakpoint, sizes: props.config.lg },
    { breakpoint: 'xl' as Breakpoint, sizes: props.config.xl },
    { breakpoint: '2xl' as Breakpoint, sizes: props.config['2xl'] },
  ].filter((breakpoint) => breakpoint.sizes !== undefined);

  return definedBreakpoints
    .map((element, index) => ({
      breakpoint: element.breakpoint,
      sizes: element.sizes,
      mediaQuery: mediaQuery(element.breakpoint, definedBreakpoints[index + 1]?.breakpoint),
    }))
    // Don't render ad blocks without sizes
    .filter((element) => element.sizes?.length);
});
</script>
